import axios from 'axios'
import { errorHandler } from '../exports/error_management'
import { buildQuery } from '../exports/queryStringBuilder'

const state = {
    types: null,
    vendors: [],
    assets: [],
    asset: null,
    assets_pagination: {},
}

const mutations = {
    SET(state, payload) {
        state.assets = payload
    },

    SET_ASSET_PAGINATION(state, pag) {
        state.assets_pagination = pag
    },

    SET_ASSET(state, payload) {
        state.asset = payload
    },

    SET_TYPES(state, payload) {
        state.types = payload
    },

    SET_VENDORS(state, payload) {
        state.vendors = payload
    },
}

const actions = {
    ////asset

    async get(context, id) {
        try {
            const resp = await axios.get(`asset/${id}`)
            console.log('get results', resp)
            const asset = resp.data.success.data
            context.commit('SET_ASSET', asset)
        } catch (err) {
            errorHandler(err)
        }
    },

    async fetch(context, params) {
        try {
            let { query, page: pg, filters } = params || {}
            query = query || ''
            pg = pg || 1
            filters = filters || {}
            const path = `asset?q=${query}&page=${pg}&${buildQuery(filters)}`
            console.log('--path--', path)
            const results = await axios.get(path)
            console.log('fetch results', results)
            let {
                data,
                current_page: page,
                per_page: pageSize,
                total,
            } = results.data.success.data

            const pag = {
                page,
                pageSize,
                total,
            }

            //const assets = data.data.success.data
            context.commit('SET', data)
            context.commit('SET_ASSET_PAGINATION', pag)
        } catch (err) {
            errorHandler(err)
        }
    },

    async create(context, { payload }) {
        try {
            const data = await axios.post(`asset`, payload)
            console.log('create results', data)
            context.dispatch('fetch') //not efficient
            //context.commit("SET_TYPE", data.success.data)
        } catch (err) {
            errorHandler(err)
        }
    },

    async update(context, { id, payload }) {
        try {
            const data = await axios.put(`asset/${id}`, payload)
            console.log('update results', data)
            context.dispatch('fetch') //not efficient
            //context.commit("SET_TYPE", data.success.data)
        } catch (err) {
            errorHandler(err)
        }
    },

    async delete(context, id) {
        try {
            await axios.delete(`asset/${id}`)
            context.dispatch('fetch') //not efficient
        } catch (err) {
            errorHandler(err)
        }
    },

    async listTypes(context) {
        try {
            const data = await axios.get(`asset-type`)
            console.log('listType results', data)
            const types = data.data.success.data
            context.commit('SET_TYPES', types)
        } catch (err) {
            errorHandler(err)
        }
    },

    async createType(context, { name, description }) {
        try {
            const data = await axios.post(`asset-type`, { name, description })
            console.log('createType results', data)
            context.dispatch('listTypes') //not efficient
            //context.commit("SET_TYPE", data.success.data)
        } catch (err) {
            errorHandler(err)
        }
    },

    async updateType(context, { id, name, description }) {
        try {
            const data = await axios.put(`asset-type/${id}`, {
                name,
                description,
            })
            console.log('updateType results', data)
            context.dispatch('listTypes') //not efficient
            //context.commit("SET_TYPE", data.success.data)
        } catch (err) {
            errorHandler(err)
        }
    },

    async deleteType(context, id) {
        try {
            await axios.delete(`asset-type/${id}`)
            context.dispatch('listTypes') //not efficient
        } catch (err) {
            errorHandler(err)
        }
    },

    //////////vendors
    async listVendors(context) {
        try {
            const data = await axios.get(`asset-vendor`)
            console.log('listVendors results', data)
            const vendors = data.data.success.data
            context.commit('SET_VENDORS', vendors)
        } catch (err) {
            errorHandler(err)
        }
    },

    async createVendor(context, { name, description }) {
        try {
            const data = await axios.post(`asset-vendor`, { name, description })
            console.log('createVendor results', data)
            context.dispatch('listVendors') //not efficient
            //context.commit("SET_TYPE", data.success.data)
        } catch (err) {
            errorHandler(err)
        }
    },

    async updateVendor(context, { id, name, description }) {
        try {
            const data = await axios.put(`asset-vendor/${id}`, {
                name,
                description,
            })
            console.log('updateVendor results', data)
            context.dispatch('listVendors') //not efficient
            //context.commit("SET_TYPE", data.success.data)
        } catch (err) {
            errorHandler(err)
        }
    },

    async deleteVendor(context, id) {
        try {
            await axios.delete(`asset-vendor/${id}`)
            context.dispatch('listVendors') //not efficient
        } catch (err) {
            errorHandler(err)
        }
    },
}

const getters = {}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
}
